import React, { Component, useContext, useEffect, useState } from 'react';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

import '../../index.css';
import * as XLSX from 'xlsx';
import {
  getTodayContentsInfo,
  getContentsPlayRange,
  getContentsList,
} from '../../modules/NetworkFunction';
import StatisticsModal from './StatisticsModal';
import AuthContext from '../../contexts/AuthContext';
import ShopModeContext from '../../contexts/ShopModeContext';

Chart.register(zoomPlugin);

let MultiChart;

function ViewContentsStatistics() {
  const { auth: token } = useContext(AuthContext);
  const { shopMode } = useContext(ShopModeContext);

  const year = new Date().getFullYear(); // 년
  const month = new Date().getMonth(); // 월
  const day = new Date().getDate(); // 일

  const [date1, setDate1] = useState(new Date(year, month, day - 5));
  const [date2, setDate2] = useState(new Date(year, month, day + 1));
  const [noVideo, setNoVideo] = useState(true);
  const [contentsNo, setContentsNo] = useState(-1);
  const [title, setTitle] = useState('');
  const [contentsList, setContentsList] = useState();

  const [isContentsLoaded, setisContentsLoaded] = useState(false);
  const [isViewLoaded, setIsViewLoaded] = useState(false);
  const [todayContents, setTodayContents] = useState([]);
  const [videoDataList, setvideoDataList] = useState([]);
  const [isVideoDataLoaded, setIsVideoDataLoaded] = useState(false);

  const [drawLoading, setDrawLoading] = useState(false);

  const date1Ref = React.useRef(null);
  const date2Ref = React.useRef(null);

  const contentsRef = React.useRef(null);
  const userNo = window.sessionStorage.getItem('userNo');

  useEffect(() => {
    date1Ref.current.value = date1.toISOString().substring(0, 10);
    date2Ref.current.value = date2.toISOString().substring(0, 10);
  }, [date1, date2]);

  useEffect(() => {
    if (!isViewLoaded) {
      getTodayContentsInfo(
        userNo,
        (v) => {
          setTodayContents(v.results);
        },
        setIsViewLoaded,
        (e) => {
          console.log(e);
          console.log('error!');
        },
        token
      );
    }
  }, []);

  useEffect(() => {
    
      getContentsList(
        {
          flag: true,
          shopMode,
          userNo,
        },
        setContentsList,
        setisContentsLoaded,
        (e) => {
          if (e) console.log(e);
        },
        token
      ).then(() => {
        buildMultiChart([]);
      });

      console.log('contentsList', contentsList);
      
  }, [isContentsLoaded, token, shopMode]);

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const makeExcel_getTodayContentsInfo = () => {
    if (todayContents.length === 0) {
      alert('조회된 콘텐츠가 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];
    const header = ['순위', '콘텐츠명', '조회수'];
    wsData.push(header);

    if (todayContents.length === 0) {
      wsData.push(['-', '-', '-']);
    } else {
      for (let i = 0; i < todayContents.length; i++) {
        wsData.push([
          i + 1,
          todayContents[i].title,
          todayContents[i].count,
        ]);
      }
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '일일 콘텐츠 재생 순위');

    XLSX.writeFile(workbook, '일일 콘텐츠 재생 순위.xlsx');
  };

  const makeExcel_getContentsPlayRange = () => {
    if (videoDataList.length === 0) {
      alert('조회된 콘텐츠가 없어 빈 엑셀 파일을 생성합니다.');
    }

    const wsData = [];
    const header = ['콘텐츠명', '0-10%', '10-20%', '20-30%', '30-40%', '40-50%', '50-60%', '60-70%', '70-80%', '80-90%', '90-100%'];
    wsData.push(header);

    if (videoDataList.length === 0) {
      wsData.push(['-', '-', '-', '-', '-', '-', '-', '-', '-', '-', '-']);
    } else {
      wsData.push([
        title,
        ...videoDataList
      ]);
    }

    const worksheet = XLSX.utils.aoa_to_sheet(wsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, '재생 구간');

    XLSX.writeFile(workbook, '분석 리포트-재생구간.xlsx');
  };

  const buildMultiChart = (dataList) => {
    let ctx = document.getElementById('MultiChart').getContext('2d');

    const existingChart = Chart.getChart('MultiChart');
    if (existingChart) {
      existingChart.destroy();
    }

    MultiChart = new Chart(ctx, {
      data: {
        labels: [
          '0-10%',
          '10-20%',
          '20-30%',
          '30-40%',
          '40-50%',
          '50-60%',
          '60-70%',
          '70-80%',
          '80-90%',
          '90-100%',
        ],
        datasets: [
          {
            type: 'line',
            label: '콘텐츠 영상 재생구간',
            data: dataList,
            fill: true,
            borderColor: 'transparent',
            backgroundColor: 'rgba(255, 215, 96, 0.6)',
            tension: 0.1,
            pointStyle: 'circle',
            pointRadius: 3.5,
            pointBackgroundColor: '#FFA800',
          },
        ],
      },
      options: {
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            min: 0,
            max: Math.max(...dataList),
            grid: {
              display: true,
            },
          },
        },
        animation: {
          duration: 750,
        },
        plugins: {
          position: 'bottom',
          legend: {
            display: false,
          },
          datalabels: {
            display: false, // 데이터 라벨 숨기기
          },
        },
      },
    });
  };

  const drawChart = () => {
    if (contentsNo < 0) {
      alert('원하시는 콘텐츠를 선택하시길 바랍니다.');
      setDrawLoading(false);
      return;
    } else if (date1 === '' || date2 === '') {
      alert('분석기간을 선택해 주시기 바랍니다.');
      setDrawLoading(false);

      return;
    } else if (date2 < date1) {
      alert('끝 날짜가 시작 날짜보다 앞서면 안됩니다.');
      setDrawLoading(false);

      return;
    }

    setNoVideo(false);
    setDrawLoading(true);

    getContentsPlayRange(
      //test
      //{contentsNo: 208, startDate: date1, endDate: date2}

      // real
      { contentsNo, startDate: date1, endDate: date2 },
      (v) => {
        if (v.results.length > 0) {
          setvideoDataList(v.results);
          buildMultiChart(v.results);
          setDrawLoading(false);

          console.log('success');
        } else {
          setNoVideo(true);
          setDrawLoading(false);
          alert('조회할 데이터가 없습니다.');
          return;
        }
      },
      setIsVideoDataLoaded,
      (e) => {
        console.log(e);
        console.log('error!');
      },
      token
    );
  };

  return (
    <div>
      <StatisticsModal
        open={modalOpen}
        close={closeModal}
        header="콘텐츠별 조회 순위"
      />

      <p
        style={{
          fontSize: 30,
          fontWeight: '400',
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        콘텐츠별 조회 순위
      </p>

      <div
        style={{
          border: '0.5px solid #848484',
          marginBottom: '40px',
          width: '788px',
        }}
      ></div>

      <p
        style={{ fontSize: '22px', fontWeight: '400px', marginBottom: '24px' }}
      >
        일일 콘텐츠 재생수 순위
      </p>
      <div
        id="contentsData"
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '676px',
          height: '148px',
          border: '1px solid #C4C4C4',
          borderRadius: '10px',
        }}
      >
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            height: '48px',
          }}
        >
          <div
            style={{
              marginRight: '16px',
              marginLeft: '16px',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#B5B5B5',
              color: '#FFFFFF',
              fontSize: '18px',
              textAlign: 'center',
            }}
          >
            1
          </div>
          <div
            style={{
              border: '0.5px solid #C4C4C4',
              height: '100%',
              marginRight: '20px',
            }}
          />
          {todayContents[0] ? (
            <div
              style={{
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
              }}
            >
              {todayContents[0].title || '콘텐츠 제목 없음'}
            </div>
          ) : (
            <div
              style={{
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                color: '#848484',
              }}
            >
              데이터 존재하지 않음
            </div>
          )}
          <div
            style={{
              position: 'absolute',
              marginLeft: '80%',
              border: '0.5px solid #C4C4C4',
              height: '100%',
            }}
          />
          {todayContents[0] ? (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
              }}
            >
              {todayContents[0].viewCount || 0} 회
            </div>
          ) : (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
                color: '#848484',
              }}
            >
              - 회
            </div>
          )}
        </div>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            height: '48px',
          }}
        >
          <div
            style={{
              marginRight: '16px',
              marginLeft: '16px',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#B5B5B5',
              color: '#FFFFFF',
              fontSize: '18px',
              textAlign: 'center',
            }}
          >
            2
          </div>
          <div
            style={{
              border: '0.5px solid #C4C4C4',
              height: '100%',
              marginRight: '20px',
            }}
          />
          {todayContents[1] ? (
            <div
              style={{
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
              }}
            >
              {todayContents[1].title || '콘텐츠 제목 없음'}
            </div>
          ) : (
            <div
              style={{
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                color: '#848484',
              }}
            >
              데이터 존재하지 않음
            </div>
          )}
          <div
            style={{
              position: 'absolute',
              marginLeft: '80%',
              border: '0.5px solid #C4C4C4',
              height: '100%',
            }}
          />
          {todayContents[1] ? (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
              }}
            >
              {todayContents[1].viewCount || 0} 회
            </div>
          ) : (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
                color: '#848484',
              }}
            >
              - 회
            </div>
          )}
        </div>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            height: '48px',
          }}
        >
          <div
            style={{
              marginRight: '16px',
              marginLeft: '16px',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              background: '#B5B5B5',
              color: '#FFFFFF',
              fontSize: '18px',
              textAlign: 'center',
            }}
          >
            3
          </div>
          <div
            style={{
              border: '0.5px solid #C4C4C4',
              height: '100%',
              marginRight: '20px',
            }}
          />
          {todayContents[2] ? (
            <div
              style={{
                fontSize: '16px',
                fontWeight: '400px',
                lineHeight: '22px',
              }}
            >
              {todayContents[2].title || '콘텐츠 제목 없음'}
            </div>
          ) : (
            <div
              style={{
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                color: '#848484',
              }}
            >
              데이터 존재하지 않음
            </div>
          )}
          <div
            style={{
              position: 'absolute',
              marginLeft: '80%',
              border: '0.5px solid #C4C4C4',
              height: '100%',
            }}
          />
          {todayContents[2] ? (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
              }}
            >
              {todayContents[2].count || 0} 회
            </div>
          ) : (
            <div
              style={{
                position: 'absolute',
                fontSize: '18px',
                fontWeight: '400px',
                lineHeight: '22px',
                marginLeft: '85%',
                color: '#848484',
              }}
            >
              - 회
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'right',
          color: '#FF7A00',
          fontWeight: 'bold',
          marginTop: '20px',
          textDecoration: 'underline',
          cursor: 'pointer',
        }}
      >
        {/* <span
          style={{
            color: "#FF7A00",
            fontWeight: "bold",
            paddingRight: "10px",
            textDecoration: "underline",
            cursor: "pointer",
            
          }}
          onClick={() => {
            console.log("상품 순위");
            openModal();
          }}
        >
          예시 결과 보기
        </span> */}
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            fontSize: '16px',
            paddingRight: '10px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            makeExcel_getTodayContentsInfo();
          }}
        >
          전체 내역 다운받기
        </span>
      </div>

      <p
        style={{
          fontSize: '22px',
          fontWeight: '400px',
          marginBottom: '24px',
          marginTop: '32px',
        }}
      >
        콘텐츠 분석 리포트 - 재생 구간
      </p>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            display: 'flex',
            width: '80px',
            height: '36px',
            background: '#CCCCCC',
            borderRadius: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: '400',
            fontSize: '16px',
          }}
        >
          동영상
        </div>

        <div style={{ width: '12px' }}></div>

        {/*이부분에 상품 정보 가져와서 map으로 처리해주면될듯*/}
        <select
          name="contents"
          ref={contentsRef}
          style={{ borderRadius: '10px', height: '36px' }}
          onChange={() => {
            setContentsNo(
              contentsRef.current.options[contentsRef.current.selectedIndex]
                .value
            );
            setTitle(
              contentsRef.current.options[contentsRef.current.selectedIndex]
                .text
            );
          }}
        >
          <option value={-1}>--Please choose an option--</option>
          {contentsList &&
            contentsList.map((contents) => {
              return (
                <option key={contents.contentsNo} value={contents.contentsNo}>
                  {contents.title || '제목 없음'}
                </option>
              );
            })}
        </select>

        <div style={{ width: '12px' }}></div>

        {/*<div style={{width:"20px", height:"20px", backgroundColor:"#CCCCCC", borderRadius:"20px"}}/>*/}

        <div
          className="btn-result"
          style={{ marginLeft: 0 }}
          onClick={() => {
            drawChart();
          }}
        >
          결과보기
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '24px',
          marginBottom: '24px',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '80px',
            height: '36px',
            background: '#CCCCCC',
            borderRadius: '10px',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: '400',
            fontSize: '16px',
          }}
        >
          분석 기간
        </div>

        <div style={{ width: '12px' }}></div>

        {/*state이용해서 그래프 그리기*/}
        <input
          type="date"
          ref={date1Ref}
          onChange={(event) => {
            const convertedDate = new Date(event.target.value);
            setDate1(convertedDate);
          }}
          max={date2.toISOString().split('T')[0]}
        />

        <p
          style={{ marginLeft: '12px', marginRight: '12px', color: '#CCCCCC' }}
        >
          ~
        </p>

        <input
          type="date"
          ref={date2Ref}
          onChange={(event) => {
            const convertedDate = new Date(event.target.value);
            setDate2(convertedDate);
          }}
          min={date1.toISOString().split('T')[0]}
        />
      </div>

      <div
        style={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {noVideo && (
          <div
            style={{ position: 'absolute', color: '#848484', fontSize: '24px' }}
          >
            선택한 동영상이 없습니다.
          </div>
        )}

        {drawLoading && (
          <div
            style={{ position: 'absolute', color: '#848484', fontSize: '24px' }}
          >
            불러오는 중...
          </div>
        )}

        {
          // videoDataList의 조회수 합이 0이면, 모든 구간의 조회수가 0입니다를 출력
          isVideoDataLoaded && videoDataList.reduce((acc, cur) => acc + cur, 0) === 0 && (
            <div
              style={{
                position: 'absolute',
                color: '#848484',
                fontSize: '24px',
              }}
            >
              모든 구간의 조회수가 0입니다.
            </div>
          )
        }

        <canvas id="MultiChart" height="180" />
        <p
          style={{
            size: '2px',
            color: '#B5B5B5',
            fontSize: '14px',
            marginTop: '10px',
            paddingLeft: '430px',
          }}
        >
          {' '}
          * 동그라미 부분에 커서를 올리면 상세 조회수 확인 가능{' '}
        </p>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'right',
          marginBottom: '20px',
        }}
      >
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            paddingRight: '10px',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            console.log('상품 순위');
            openModal();
          }}
        >
          예시 결과 보기
        </span>
        <span
          style={{
            color: '#FF7A00',
            fontWeight: 'bold',
            marginTop: '10px',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
          onClick={() => {
            makeExcel_getContentsPlayRange();
          }}
        >
          전체 내역 다운 받기
        </span>
      </div>
    </div>
  );
}
export default ViewContentsStatistics;
